import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _class, _defaultPosition, _rawData, _dag, _DAG_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import DAGMap from "dag-map";
import { bind } from "discourse-common/utils/decorators";
function ensureArray(val) {
  return Array.isArray(val) ? val : [val];
}
let DAG = (_class = (_defaultPosition = /*#__PURE__*/new WeakMap(), _rawData = /*#__PURE__*/new WeakMap(), _dag = /*#__PURE__*/new WeakMap(), _DAG_brand = /*#__PURE__*/new WeakSet(), class DAG {
  constructor(args) {
    _classPrivateMethodInitSpec(this, _DAG_brand);
    _classPrivateFieldInitSpec(this, _defaultPosition, void 0);
    _classPrivateFieldInitSpec(this, _rawData, new Map());
    _classPrivateFieldInitSpec(this, _dag, new DAGMap());
    // allows for custom default positioning of new items added to the DAG, eg
    // new DAG({ defaultPosition: { before: "foo", after: "bar" } });
    _classPrivateFieldSet(_defaultPosition, this, args?.defaultPosition || {});
  }
  /**
   * Adds a key/value pair to the map. Can optionally specify before/after position requirements.
   *
   * @param {string} key The key of the item to be added. Can be referenced by other member's position parameters.
   * @param {any} value
   * @param {Object} position
   * @param {string | string[]} position.before A key or array of keys of items which should appear before this one.
   * @param {string | string[]} position.after A key or array of keys of items which should appear after this one.
   */
  add(key, value, position) {
    position ||= _assertClassBrand(_DAG_brand, this, _defaultPositionForKey).call(this, key);
    const {
      before,
      after
    } = position;
    _classPrivateFieldGet(_rawData, this).set(key, {
      value,
      before,
      after
    });
    _classPrivateFieldGet(_dag, this).add(key, value, before, after);
  }

  /**
   * Remove an item from the map by key. no-op if the key does not exist.
   *
   * @param {string} key The key of the item to be removed.
   */
  delete(key) {
    _classPrivateFieldGet(_rawData, this).delete(key);
    _assertClassBrand(_DAG_brand, this, _refreshDAG).call(this);
  }

  /**
   * Change the positioning rules of an existing item in the map. Will replace all existing rules. No-op if the key does not exist.
   *
   * @param {string} key
   * @param {string | string[]} position.before A key or array of keys of items which should appear before this one.
   * @param {string | string[]} position.after A key or array of keys of items which should appear after this one.
   */
  reposition(key, _ref) {
    let {
      before,
      after
    } = _ref;
    const node = _classPrivateFieldGet(_rawData, this).get(key);
    if (node) {
      node.before = before;
      node.after = after;
    }
    _assertClassBrand(_DAG_brand, this, _refreshDAG).call(this);
  }

  /**
   * Check whether an item exists in the map.
   * @param {string} key
   * @returns {boolean}
   *
   */
  has(key) {
    return _classPrivateFieldGet(_rawData, this).has(key);
  }

  /**
   * Return the resolved key/value pairs in the map. The order of the pairs is determined by the before/after rules.
   * @returns {Array<[key: string, value: any]}>} An array of key/value pairs.
   *
   */
  resolve() {
    const result = [];
    _classPrivateFieldGet(_dag, this).each((key, value) => {
      // We need to filter keys that do not exist in the rawData because the DAGMap will insert a vertex for
      // dependencies, for example if an item has a "before: search" dependency, the "search" vertex will be included
      // even if it was explicitly excluded from the raw data.
      if (this.has(key)) {
        result.push({
          key,
          value
        });
      }
    });
    return result;
  }

  /**
   * DAGMap doesn't support removing or modifying keys, so we
   * need to completely recreate it from the raw data
   */
}), (_applyDecoratedDescriptor(_class.prototype, "resolve", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "resolve"), _class.prototype)), _class);
function _defaultPositionForKey(key) {
  const pos = {
    ..._classPrivateFieldGet(_defaultPosition, this)
  };
  if (ensureArray(pos.before).includes(key)) {
    delete pos.before;
  }
  if (ensureArray(pos.after).includes(key)) {
    delete pos.after;
  }
  return pos;
}
function _refreshDAG() {
  const newDAG = new DAGMap();
  for (const [key, {
    value,
    before,
    after
  }] of _classPrivateFieldGet(_rawData, this)) {
    newDAG.add(key, value, before, after);
  }
  _classPrivateFieldSet(_dag, this, newDAG);
}
export { DAG as default };